export const VISITOR_CSV_COLUMN_MAP = {
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  phone: 'Phone',
  companyName: 'Company',
} as const;

/**
 * Array of required Visitor CSV headers
 */
export const VISITOR_CSV_HEADERS = Object.values(VISITOR_CSV_COLUMN_MAP);

/**
 * Maximum number of visitors allowed per CSV upload
 */
export const MAX_VISITORS_PER_UPLOAD = 50;

/** Delimiters spreadsheets write; PapaParse auto-detects from this list. */
export const CSV_DELIMITERS_TO_GUESS = [',', ';', '\t'];
